import React from 'react';
import './Header.css';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SearchIcon from '@mui/icons-material/Search';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './Firebase';

function Header({ user, searchTerm, setSearchTerm }) {
  const [{ cart }] = useStateValue();

  const handleSignOut = () => {
    auth.signOut();
  };

  return (
    <div className="header">
      <Link to="/" style={{ textDecoration: 'none' }}>
        <div className="header__logo">
          <StorefrontIcon className="header__logoImage" fontSize="large" />
          <h2 className="header__logoTitle">sMart</h2>
        </div>
      </Link>

      {/* Search bar */}
      <form className="header__search" onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          className="header__searchInput"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search products..."
        />
        <SearchIcon className="header__searchIcon" />
      </form>

      <div className="header__nav">
        {user ? (
          <div className="nav__item">
            <span className="nav__itemLineOne">Welcome,</span>
            <span className="nav__itemLineTwo">{user.email}</span>
          </div>
        ) : (
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <div className="nav__item">
              <span className="nav__itemLineOne">Hello Guest</span>
              <span className="nav__itemLineTwo">Sign In</span>
            </div>
          </Link>
        )}

        {user && (
          <div className="nav__item">
            <span className="nav__itemLineOne">Not you?</span>
            <span
              className="nav__itemLineTwo"
              style={{ cursor: 'pointer', color: 'red' }}
              onClick={handleSignOut}
            >
              Sign Out
            </span>
          </div>
        )}

        <div className="nav__item">
          <span className="nav__itemLineOne">Your</span>
          <span className="nav__itemLineTwo">Shop</span>
        </div>

        <Link to="/checkout" style={{ textDecoration: 'none' }}>
          <div className="nav__itemBasket">
            <ShoppingBasketIcon />
            <span className="nav__itemLineTwo nav__basketCount">{cart.length}</span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
